import { twMerge } from 'tailwind-merge';

/** Join class names — merges conflicting Tailwind utilities (WI-3 Card adoption). */
export function cn(...parts) {
  return twMerge(parts.filter(Boolean).join(' '));
}
